import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条 样式

/* layout */
import Layout from '../views/layout/Layout';

/* iframe source page */
import Iframe from '../views/iframe';
import mainPage from '../views/mainPage';
/* fond auth callback page */
import AuthCallback from '../views/callback';

import noPermission from '../views/exclude/noPermission';
/* in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading */
const _import = require('./_import_' + process.env.NODE_ENV);

/* home log in and out */
import {
    globalConfig,
    oauth
} from 'static/config'

const Login = _import('home/login');
const casLogin = _import('home/casLogin');
const casLogout = _import('home/casLogout');
const casLogoutAll = _import('home/casLogoutAll');
const ChangePwd = _import('home/changePwd');

/* error page */
const Err404 = _import('error/404');
const Err401 = _import('error/401');
//import exceptTest from '../views/except/exceptTest'
//import exceptTest2 from '../views/except/exceptTest2'

/* 教务管理系统配置 */
import schemeView from '../views/teachingManage/teachingScheme/schemeView';
import teachingScheme from '../views/teachingManage/teachingScheme/teachingScheme';
import major from '../views/baseInfo/major';

/* 迎新登录页面 */
//import welcomeLogin from '../views/home/welcomeLogin';

/* 首页欢迎页面 */
import welcome from '../views/welcome';
import homePage from '../views/homePage';
import firstPage from '../views/firstPage';
import evaluatorsLogin from '../views/skillRecognition/evaluatorsLogin/evaluatorsLogin'
import candidateList from '../views/skillRecognition/evaluatorsLogin/candidateList'

/* 验收模块 */
import graduate from '../views/baseInfo/student/graduate';
import graduateDesign from '../views/scoreManage/register/graduateDesign';
import teacher from '../views/baseInfo/teacher';
import changeMajor from '../views/baseInfo/student/changeMajor';
import academicWarning from '../views/scoreManage/academicWarning';
import teachingPlanImplementation from '../views/timetableManage/statistics/teachingPlanImplementation';
import experimentManage from '../views/timetableManage/arrange/experimentManage';
import message from '../views/message/message';
import tempHighBasicReport from '../views/basicReport/tempHighBasicReport';
import courseStandard from '../views/teachingManage/courseStandard/criterion_for_curriculum';
import longtermAdjust from '../views/timetableManage//arrange/longtermAdjust';

/* 移动端页面 */
import autoLogin from '../views/mobile/autoLogin';
import mobileHomePage from '../views/mobile/mobileHomePage';
import timetable from '../views/mobile/timetable';
import statusApply from '../views/mobile/statusApply';
import creditIdentifiedApply from '../views/mobile/creditIdentified';
import electiveSelection from '../views/mobile/electiveSelection';
import sportElectiveSelection from '../views/mobile/sportElectiveSelection';
import stuPersonalScore from '../views/mobile/stuPersonalScore';
import adjustClasses from '../views/mobile/adjustClasses';
import adjustMonitor from '../views/mobile/adjustMonitor';
import questionnaireServerMobile from '../views/mobile/questionnaireServerMobile';
import examSchedule from '../views/mobile/examSchedule';
import specialScoreApply from '../views/mobile/specialScoreApply';
import siteApply from '../views/mobile/siteApply';
import outsideStudentSelection from '../views/mobile/outsideStudentSelection';
import retakeApply from '../views/mobile/retakeApply';
import stuPracticeMobile from '../views/mobile/stuPracticeMobile';
import practiceManageMobile from '../views/mobile/practiceManageMobile';
import questionnaireSurveyMobile from '../views/mobile/questionnaireSurveyMobile';
import atSchoolCertificateStuMobile from '../views/mobile/atSchoolCertificateStuMobile';
import studentSelectionSportAdultEducationMobile from '../views/mobile/adultEducation/studentSelectionSportAdultEducationMobile'
import stuTimetableAdultEducationMobile from '../views/mobile/adultEducation/stuTimetableAdultEducationMobile'
import teaTimetableDirectAdultEducationMobile from '../views/mobile/adultEducation/teaTimetableDirectAdultEducationMobile'
import teaTimetableDirectSkillsTrainingMobile from '../views/mobile/skillsTraining/teaTimetableDirectSkillsTrainingMobile'

//评教服务
import questionnaireServer from '../views/evaluateManage/questionnaireServer';
import tempQuestionnaireServer from '../views/evaluateManage/tempQuestionnaireServer';
import questionnaireSurvey from '../views/evaluateManage/questionnaireSurvey';

import tempQuestionnaireSet from '../views/evaluateManage/tempQuestionnaireSet';
import tempQuestionSet from '../views/evaluateManage/tempQuestionSet';
import tempSituation from '../views/evaluateManage/tempSituation';


/* 成绩系统临时页面 */
import subjectScoreReport from '../views/scoreManage/statistics/subjectScoreReport';
import examQualityAnalysis from '../views/scoreManage/statistics/examQualityAnalysis';
import scoreDefaultConfig from '../views/scoreManage/setting/defaultConfig';

import tempExemptStudy from '../views/scoreManage/setting/tempExemptStudy';
import tempClassScoreInfo from '../views/scoreManage/query/tempClassScoreInfo';
import siteTimetable from '../views/timetableManage/arrange/siteTimetable';

import tempSemesterScore from '../views/scoreManage/query/tempSemesterScore';
import tempFailSubject from '../views/scoreManage/query/tempFailSubject';
import tempFinalResitStuList from '../views/scoreManage/query/tempFinalResitStuList';
import tempRepeatGradeStuList from '../views/scoreManage/query/tempRepeatGradeStuList';
import tempResitStuList from '../views/scoreManage/query/tempResitStuList';
import tempStuScoreList from '../views/scoreManage/query/tempStuScoreList';
import tempPointStatistics from '../views/scoreManage/statistics/tempPointStatistics';
import Instructor from "../views/scoreManage/register/Instructor";
import GuidanceProcess from "../views/scoreManage/register/GuidanceProcess";
import stuPersonalScoreAdultEducationMobile from "../views/mobile/adultEducation/stuPersonalScoreAdultEducationMobile.vue";
import stuTimetableSkillsTrainingMobile from "../views/mobile/skillsTraining/stuTimetableSkillsTrainingMobile.vue";
import stuPersonalScoreSkillsTrainingMobile from "../views/mobile/skillsTraining/stuPersonalScoreSkillsTrainingMobile.vue";
import stuServicesAssessmentListMobile from "../views/mobile/stuServicesAssessmentListMobile";

/**
 * icon : the icon show in the sidebar
 * hidden : if hidden:true will not show in the sidebar
 * redirect : if redirect:noredirect will not redirct in the levelbar
 * noDropdown : if noDropdown:true will not has submenu
 * meta : { role: ['admin'] }  will control the page role
 **/
export const constantRouterMap = [{
    path: '/login',
    component: Login,
    hidden: true
},
    {
        path: '/casLogin',
        component: casLogin,
        hidden: true,
    },
    {
        path: '/casLogout',
        component: casLogout,
        hidden: true,
    },
    {
        path: '/casLogoutAll',
        component: casLogoutAll,
        hidden: true,
    },
    {
        path: '/changePwd',
        component: ChangePwd,
        hidden: true
    },
    {
        path: '/auth/callback',
        component: AuthCallback,
        hidden: true
    },
    {
        path: '/404',
        component: Err404,
        hidden: true
    },
    {
        path: '/401',
        component: Err401,
        hidden: true
    },
    {
        path: '/homePage',
        component: homePage,
        //name: '首页',
        hidden: true,
    },
    {
        path: '/evaluatorsLogin',
        component: evaluatorsLogin,
        hidden: true,
    },
    //candidateList
    {
        path: '/candidateList',
        component: candidateList,
        hidden: true,
    },
    {
        path: '/firstPage',
        component: firstPage,
        //name: '首页',
        hidden: true,
    },
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        name: '默认首页',
        hidden: true,
        children: [{
            path: 'dashboard',
            component: Iframe
        },
            {
                path: '/Instructor',
                component: Instructor,
                name: '指导教师管理',
                hidden: true,
            },
            {
                path: '/GuidanceProcess',
                component: GuidanceProcess,
                name: '指导过程',
                hidden: true,
            },
            {
                path: '/teachingScheme',
                component: teachingScheme,
                name: '培养方案',
                hidden: true,
            },
            {
                path: '/graduate',
                component: graduate,
                name: '毕业审核',
                hidden: true,
            },
            {
                path: '/graduateDesign',
                component: graduateDesign,
                name: '毕业设计（论文）管理',
                hidden: true,
            },
            {
                path: '/teacher',
                component: teacher,
                //name: '师资管理',
                hidden: true,
            },
            {
                path: '/changeMajor',
                component: changeMajor,
                name: '转专业管理',
                hidden: true,
            },
            {
                path: '/academicWarning',
                component: academicWarning,
                name: '学业预警',
                hidden: true,
            },
            {
                path: '/mainPage',
                component: mainPage,
                name: '消息提醒',
                hidden: true,
            },
            {
                path: '/teachingPlanImplementation',
                component: teachingPlanImplementation,
                name: '计划完成审核',
                hidden: true,
            },
            {
                path: '/experimentManage',
                component: experimentManage,
                //name: '实验管理',
                hidden: true,
            },
            {
                path: '/tempHighBasicReport',
                component: tempHighBasicReport,
                name: '高基报表',
                hidden: true,
            },
            {
                path: '/message',
                component: message,
                name: '消息通知',
                hidden: true,
            },
            {
                path: '/longtermAdjust',
                component: longtermAdjust,
                name: '消息通知',
                hidden: true,
            },
        ]
    },
    {
        path: '/index',
        component: Layout,
        name: getSubsystemName(),
        hidden: true,
        children: [{
            path: '',
            component: welcome
        }]
    },
    {
        path: '/noPermission',
        component: Layout,
        name: '无操作权限',
        hidden: true,
        children: [{
            path: '',
            component: noPermission
        }]
    },
    // {
    //     path: '/exceptTest',
    //     component: exceptTest,
    //     hidden: true
    // },
    // {
    //     path: '/exceptTest2',
    //     component: exceptTest2,
    //     hidden: true
    // },
    //教务管理系统配置
    {
        path: '/schemeView',
        component: schemeView,
        name: 'schemeView',
        hidden: true,
    },
    {
        path: '/courseStandard',
        component: courseStandard,
        name: 'courseStandard',
        hidden: true,
    },
    {
        path: '/scheme',
        component: teachingScheme,
        name: 'teachingScheme',
        hidden: true,
    },
    {
        path: '/major',
        component: major,
        name: 'major',
        hidden: true,
    },
    /*
    {
        path: '/welcome',
        component: welcomeLogin,
        name: 'welcome',
        hidden: true,
    },
    */
    //移动端页面
    {
        path: '/m/wx/login',
        component: autoLogin,
        name: '登录',
        hidden: true,
    },
    {
        path: '/m/home',
        component: mobileHomePage,
        //name: '首页',
        hidden: true,
    },
    {
        path: '/m/wx/home',
        component: mobileHomePage,
        //name: '首页',
        hidden: true,
    },
    {
        path: '/m/wx/timetable',
        component: timetable,
        name: '课程表',
        hidden: true,
    },
    {
        path: '/m/wx/status',
        component: statusApply,
        name: '学籍异动申请',
        hidden: true,
    },
    {
        path: '/m/wx/credit',
        component: creditIdentifiedApply,
        name: '学分认定申请',
        hidden: true,
    },
    {
        path: '/m/wx/electiveSelection',
        component: electiveSelection,
        name: '选修课选课',
        hidden: true,
    },
    {
        path: '/m/wx/sportElectiveSelection',
        component: sportElectiveSelection,
        name: '体育选修课选课',
        hidden: true,
    },
    {
        path: '/m/wx/adjustClasses',
        component: adjustClasses,
        //name: '调课申请',
        hidden: true,
    },
    {
        path: '/m/wx/adjustMonitor',
        component: adjustMonitor,
        name: '调课确认',
        hidden: true,
    },
    {
        path: '/m/wx/examSchedule',
        component: examSchedule,
        name: '考试查询',
        hidden: true,
    },
    {
        path: '/m/wx/specialScoreApply',
        component: specialScoreApply,
        name: '特殊成绩申请',
        hidden: true,
    },
    {
        path: '/m/wx/stuPersonalScore',
        component: stuPersonalScore,
        name: '成绩查询',
        hidden: true,
    },
    {
        path: '/m/wx/questionnaireServer',
        component: questionnaireServerMobile,
        //name: '评教服务',
        hidden: true,
    },
    {
        path: '/m/wx/siteApply',
        component: siteApply,
        name: '场地申请',
        hidden: true,
    },
    {
        path: '/m/wx/outsideStudentSelection',
        component: outsideStudentSelection,
        name: '外考报名',
        hidden: true,
    },
    {
        path: '/m/wx/retakeApply',
        component: retakeApply,
        name: '重修申请',
        hidden: true,
    },
    {
        path: '/m/wx/stuPracticeMobile',
        component: stuPracticeMobile,
        name: '实习信息',
        hidden: true,
    },
    {
        path: '/m/wx/practiceManageMobile',
        component: practiceManageMobile,
        name: '实习管理',
        hidden: true,
    },
    //评教服务
    {
        path: "/evaluateManage/questionnaireServer",
        component: questionnaireServer,
        //name: '评教服务',
        hidden: true,
    },
    {
        path: "/evaluateManage/tempQuestionnaireServer",
        component: tempQuestionnaireServer,
        //name: '评教服务',
        hidden: true,
    },
    {
        path: "/m/wx/questionnaireSurveyMobile",
        component: questionnaireSurveyMobile,
        //name: '问卷调查',
        hidden: true,
    },
    {
        path: "/m/wx/atSchoolCertificateStuMobile",
        component: atSchoolCertificateStuMobile,
        //name: '在校证明',
        hidden: true,
    },
    {
        path: '/tempQuestionnaireSet',
        component: tempQuestionnaireSet,
        name: '问卷设置',
        hidden: true,
    },
    {
        path: '/tempQuestionSet',
        component: tempQuestionSet,
        name: '题目设置',
        hidden: true,
    },
    {
        path: '/tempSituation',
        component: tempSituation,
        name: '问卷情况',
        hidden: true,
    },
    {
        path: '/questionnaireSurvey',
        component: questionnaireSurvey,
        name: '问卷调查',
        hidden: true,
    },
    //临时配置页面（便于老框架调用）
    {
        path: '/subjectScoreReport',
        component: subjectScoreReport,
        name: '成绩登记表',
        hidden: true,
    },
    {
        path: '/examQualityAnalysis',
        component: examQualityAnalysis,
        name: '试卷质量分析报告',
        hidden: true,
    },
    {
        path: '/scoreDefaultConfig',
        component: scoreDefaultConfig,
        name: '成绩默认配置',
        hidden: true,
    },
    {
        path: '/siteTimetable',
        component: siteTimetable,
        //name: '教室课表',
        hidden: true,
    },
    {
        path: '/tempExemptStudy',
        component: tempExemptStudy,
        name: '免修设置',
        hidden: true,
    },
    {
        path: '/tempClassScoreInfo',
        component: tempClassScoreInfo,
        name: '整班成绩查询',
        hidden: true,
    },
    {
        path: '/tempSemesterScore',
        component: tempSemesterScore,
        name: '学年学期成绩查询',
        hidden: true,
    },

    {
        path: '/tempFailSubject',
        component: tempFailSubject,
        name: '不合格科目查询',
        hidden: true,
    },
    {
        path: '/tempFinalResitStuList',
        component: tempFinalResitStuList,
        name: '大补考名单',
        hidden: true,
    },
    {
        path: '/tempRepeatGradeStuList',
        component: tempRepeatGradeStuList,
        name: '留级名单',
        hidden: true,
    },
    {
        path: '/tempResitStuList',
        component: tempResitStuList,
        name: '补考名单',
        hidden: true,
    },
    {
        path: '/tempStuScoreList',
        component: tempStuScoreList,
        name: '学生成绩单',
        hidden: true,
    },
    {
        path: '/tempPointStatistics',
        component: tempPointStatistics,
        name: '绩点统计',
        hidden: true,
    },
    {
        path: "/m/wx/studentSelectionSportAdultEducationMobile",
        component: studentSelectionSportAdultEducationMobile,
        hidden: true,
    },
    {
        path: "/m/wx/stuTimetableAdultEducationMobile",
        component: stuTimetableAdultEducationMobile,
        hidden: true,
    },
    {
        path: "/m/wx/teaTimetableDirectAdultEducationMobile",
        component: teaTimetableDirectAdultEducationMobile,
        hidden: true,
    },
    {
        path: "/m/wx/teaTimetableDirectSkillsTrainingMobile",
        component: teaTimetableDirectSkillsTrainingMobile,
        hidden: true,
    },
    {
        path: "/m/wx/stuPersonalScoreAdultEducationMobile",
        component: stuPersonalScoreAdultEducationMobile,
        //name: '成人教育成绩查询',
        hidden: true,
    },
    {
        path: "/m/wx/stuTimetableSkillsTrainingMobile",
        component: stuTimetableSkillsTrainingMobile,
        //name: '技能培训课表',
        hidden: true,
    },
    {
        path: "/m/wx/stuPersonalScoreSkillsTrainingMobile",
        component: stuPersonalScoreSkillsTrainingMobile,
        //name: '技能培训成绩查询',
        hidden: true,
    },
    {
        path: "/m/wx/stuServicesAssessmentListMobile",
        component: stuServicesAssessmentListMobile,
        //name: '技能认定成绩查询',
        hidden: true,
    },
];

function getSubsystemName() {
    let subsystemName = '首页';

    if (localStorage.getItem('subsystemName')) {
        subsystemName = localStorage.getItem('subsystemName');
    }

    return subsystemName;
}

export const asyncRouterMap = [{
    path: '*',
    redirect: '/404',
    hidden: true
}];

// 全局初始化-路由
Vue.use(Router);

const router = new Router({
    //开发环境启动项目，地址栏将没有#
    base: "eam",
    // mode: 'hash', //后端支持可开
    scrollBehavior: () => ({
        y: 0
    }),
    routes: constantRouterMap
});
//不进行验证的路径集合
const exceptRouters = ['/welcome','/evaluatorsLogin','/candidateList','/login']
//验证是否在集合内
function checkExcept(toPath) {
    for (let x in exceptRouters) {
        if (exceptRouters[x] === toPath) {
            return true
        }
    }
    return false
}

//验证是否为微信链接
function verifyWechatUrl(path) {
    return path.substring(0, 5) === '/m/wx';
}

// 开始Progress
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = '教务管理系统';
    }

    NProgress.start();

    //验证跳转路径是否为无需登录页面
    if (checkExcept(to.path)) {
        // console.log("router=>不验证token")
        next();
    } else if (verifyWechatUrl(to.path)) { //判断如果为企业微信页面
        //判断是否为自动登录也且未登录
        if (to.path != '/m/wx/login' && !localStorage.getItem("x-token")) {
            localStorage.clear();
            localStorage.setItem("wechat_topath", to.path);

            //跳转自动登录页面（跳转微信授权链接）
            const redirectUrl = encodeURIComponent(globalConfig.FONT_PROXY_PATH + '/#/m/wx/login');
            location.href = oauth.wechat.authUrl +
                'appid=' + oauth.wechat.corpId +
                '&redirect_uri=' + redirectUrl +
                '&response_type=code' +
                '&scope=snsapi_base' +
                '&state=STATE#wechat_redirect';
            return;
        } else {
            next();
        }
    } else {
        //判断如果是新打开的浏览器清除登录信息
        if (document.cookie == '') {
            localStorage.removeItem('x-token');
            localStorage.removeItem('user');
            localStorage.removeItem('name');
            // localStorage.clear();
        }
        //通过登陆人token判断是否已登录
        let xToken = to.query.xtoken || localStorage.getItem("x-token");
        if (!xToken && to.path != '/casLogin' && to.path != '/login') {
            localStorage.clear();
            //判断是普通登录还是单点登录
            if (globalConfig.CASSWITCH) {
                //记录单点登录成功后的跳转路径
                if (to.path != '/casLogin') {
                    localStorage.setItem("temp_topath", to.fullPath);
                }
                location.href = globalConfig.CASURL + '?service=' + encodeURIComponent(globalConfig.HOST_PROXY_ADMIN + '/casLogin');
                return;
            } else {
                next({path: '/login'});
            }
        } else {
            next();
        }
    }
});

// 结束Progress
router.afterEach(() => {
    NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js